@if (message(); as text) {
  <section>
    <p class="errors"><i class="fal fa-triangle-exclamation"></i>&nbsp;{{ text | translate }}</p>
  </section>
}
